import React, { useEffect, useState } from "react";
import TableContainer from "../../Components/TableContainer/TableContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { loader, snackbar } from "../../utils";
import { AiTwotoneDelete } from "react-icons/ai";
import { Modal, ModalBody } from "reactstrap";
import { GoInfo } from "react-icons/go";
import {
  addPlatFormBanner,
  deleteDocs,
  deletePlatFormBanner,
  getAllPlatFormSliderImages,
  updatePlatFormBanner,
} from "../../Components/service/admin";
import { baseUrl } from "../../Components/service/Api";
import { FaRegEdit } from "react-icons/fa";

export default function TVSlider() {
  const [searchInput, setSearchInput] = useState("");
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteImg, setDeleteImg] = useState("");
  const [priority, setPriority] = useState("");
  const [title, setTitle] = useState("");
  const [docId, setDocId] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState("");
  const [channelUrl, setChannelUrl] = useState("");
  const [activeTab, setActiveTab] = useState("tv");
  const [type, setType] = useState("tv"); // Initialize to match activeTab

  const getEvent = async (type) => {
    loader.start();
    const res = await getAllPlatFormSliderImages(type);
    let data2 = res?.data?.data;
    let newRes = data2?.map((res, index) => {
      return {
        ...res,
        sno: index + 1,
      };
    });

    setData(newRes);
    loader.stop();
  };

  function paginate(eventData, cpage) {
    const filteredData = eventData.filter(
      (res) =>
        res.Name &&
        typeof res.Name === "string" &&
        res.Name.toLowerCase().includes(searchInput.toLowerCase())
    );
    const startIndex = cpage * rowsPerPage;
    const slicedData = filteredData.slice(startIndex, startIndex + rowsPerPage);
  }

  useEffect(() => {
    getEvent(activeTab);
  }, [activeTab, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    paginate(allData, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function addData() {
    // Only require file for new banners, not for updates
    if (docId === "" && file?.name == undefined) {
      snackbar.error("Please select image");
      return;
    }

    // Validate that both video and channelUrl are not provided
    if (videoFile && channelUrl.trim()) {
      snackbar.error("Please select either video OR channel URL, not both");
      return;
    }

    loader.start();
    try {
      const fileData = new FormData();

      // Only append file if a new file is selected
      if (file) {
        let fieldName = file?.type.startsWith("video") ? "video" : "banner";
        fileData.append(fieldName, file);
      }
      if (priority) {
        fileData.append("priority", priority);
      }
      if (title) {
        fileData.append("title", title);
      }
      // Handle video vs channelUrl - only send what actually exists
      if (videoFile) {
        fileData.append("video", videoFile);
      } else if (channelUrl && channelUrl.trim() && channelUrl.trim() !== "") {
        fileData.append("channelUrl", channelUrl.trim());
      } else if (docId !== "") {
        // When editing, explicitly send empty channelUrl to remove the old URL/video
        fileData.append("channelUrl", "");
      }
      // Use type from form if set, otherwise use activeTab
      const platformType = type.trim() || activeTab;
      fileData.append("type", platformType);

      if (docId == "") {
        let res = await addPlatFormBanner(fileData);
        snackbar.success("New banner added successfully");
      } else {
        await updatePlatFormBanner(docId, fileData);
        snackbar.success("Banner updated successfully");
      }
      setDocId("");
      setFile(null);
      setPreview("");
      setVideoFile(null);
      setVideoPreview("");
      setChannelUrl("");
      setPriority("");
      setTitle("");
      setType("");
      setAddModal(false);
      await getEvent(activeTab);
    } catch (err) {
      console.log(err);
      snackbar.error(
        err?.response?.data?.errormessage ||
          err?.message ||
          "Failed to save banner"
      );
    } finally {
      loader.stop();
    }
  }

  async function deleteBanner() {
    loader.start();
    try {
      await deleteDocs([deleteImg]);
      let res = await deletePlatFormBanner(deleteId);
      setDeleteId("");
      setDeleteModal(false);
      snackbar.success("Banner deleted successfully");
      await getEvent(activeTab);
    } catch (err) {
      console.log(err);
      snackbar.error(
        err?.response?.data?.errormessage ||
          err?.message ||
          "Failed to delete banner"
      );
    } finally {
      loader.stop();
    }
  }

  const handleTabClick = (tab) => {
    // Reset form data when switching tabs
    setDocId("");
    setPreview("");
    setVideoPreview("");
    setPriority("");
    setTitle("");
    setChannelUrl("");
    setType(tab); // Set type to match the tab
    setFile(null);
    setVideoFile(null);

    getEvent(tab);
    setActiveTab(tab);
  };

  return (
    <>
      <Modal centered isOpen={addModal} size="lg">
        <ModalBody>
          <div className="py-3">
            <h5 className="mb-3">Add TV Slider Banner</h5>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="type"
                    className="form-label fw-semibold text-secondary mb-1"
                  >
                    Type
                  </label>

                  <select
                    name="type"
                    id="type"
                    className="form-select shadow-sm"
                    style={{
                      borderRadius: "8px",
                      padding: "8px 12px",
                      borderColor: "#d0d7de",
                      backgroundColor: "#f8fafc",
                    }}
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <option value="tv">TV</option>
                    <option value="mobile">Mobile</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-secondary mb-1">
                    Priority
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm shadow-sm"
                    style={{
                      borderRadius: "8px",
                      borderColor: "#d0d7de",
                      padding: "8px 12px",
                      backgroundColor: "#f8fafc",
                    }}
                    placeholder="Enter priority"
                    value={priority}
                    onChange={(e) => setPriority(e.target.value)}
                    min={0}
                  />
                </div>

                <label className="form-label fs-7 mb-1">Banner Image *</label>
                <div
                  style={{
                    border: "2px dashed #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  {preview !== "" ? (
                    <div
                      style={{
                        width: "100%",
                        height: "120px",
                        overflow: "hidden",
                        borderRadius: "4px",
                      }}
                    >
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        src={preview}
                        alt=""
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        padding: "20px",
                        color: "#666",
                        fontSize: "14px",
                      }}
                    >
                      1920 x 1080
                    </div>
                  )}
                  <label
                    className="btn btn-sm btn-outline-primary mt-2"
                    htmlFor="bannerimg"
                  >
                    Choose Image
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label fs-7 mb-1">
                  Channel URL (Optional)
                </label>
                <input
                  type="url"
                  className={`form-control form-control-sm ${
                    videoFile ? "bg-light text-muted" : ""
                  }`}
                  placeholder="http://139.5.197.107/hls/modn/list/8070/playlist.m3u8"
                  value={channelUrl}
                  disabled={videoFile !== null}
                  onChange={(e) => {
                    setChannelUrl(e.target.value);
                    // Clear video when channel URL is entered
                    if (e.target.value.trim()) {
                      setVideoFile(null);
                      setVideoPreview("");
                    }
                  }}
                />
                <small className="text-muted mt-1 d-block">
                  {videoFile
                    ? "Disabled - Video is selected"
                    : "Enter channel URL with .m3u8 formate (OR select video below) "}
                </small>
              </div>
            </div>

            <input
              type="file"
              hidden
              id="bannerimg"
              accept="image/* , video/*"
              onChange={(e) => {
                const file = e.target.files[0];

                if (!file) return;

                const imageTypes = [
                  "image/png",
                  "image/jpeg",
                  "image/jpg",
                  "image/jifi",
                ];
                const videoTypes = ["video/mp4", "video/webm", "video/ogg"];

                if (![...imageTypes, ...videoTypes].includes(file.type)) {
                  snackbar.error(
                    "File must be a valid image (PNG, JPG, JPEG, JIFI) or video (MP4, WEBM, OGG)."
                  );
                  return;
                }

                setFile(file);

                const previewUrl = URL.createObjectURL(file);
                setPreview(previewUrl);
              }}
            />

            <div className="row mt-3">
              <div className="col-md-6">
                <label className="form-label fs-7 mb-1">Video (Optional)</label>
                <div
                  style={{
                    border: `2px dashed ${channelUrl.trim() ? "#ccc" : "#ddd"}`,
                    borderRadius: "8px",
                    padding: "15px",
                    textAlign: "center",
                    backgroundColor: channelUrl.trim()
                      ? "#f8f9fa"
                      : "transparent",
                    opacity: channelUrl.trim() ? 0.6 : 1,
                  }}
                >
                  {videoPreview !== "" ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100px",
                        overflow: "hidden",
                        borderRadius: "4px",
                      }}
                    >
                      <video
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        src={videoPreview}
                        controls
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        padding: "15px",
                        color: "#666",
                        fontSize: "14px",
                      }}
                    >
                      <p>Video Upload</p>
                      <p
                        style={{
                          padding: "10px",
                          color: "#666",
                          fontSize: "10px",
                        }}
                      >
                        Supported Video Formats: MP4, MOV, MKV, OGG (Max Size:
                        10MB)
                      </p>
                    </div>
                  )}
                  <label
                    className={`btn btn-sm mt-2 ${
                      channelUrl.trim()
                        ? "btn-outline-secondary disabled"
                        : "btn-outline-secondary"
                    }`}
                    htmlFor="videofile"
                    style={{
                      pointerEvents: channelUrl.trim() ? "none" : "auto",
                    }}
                  >
                    {channelUrl.trim() ? "Disabled" : "Choose Video"}
                  </label>
                </div>
              </div>
              <div className="col-md-6"></div>
            </div>

            <input
              type="file"
              hidden
              id="videofile"
              accept="video/mp4,video/webm,video/ogg"
              disabled={channelUrl.trim() !== ""}
              onChange={(e) => {
                const file = e.target.files[0];

                if (!file) return;

                const videoTypes = ["video/mp4", "video/webm", "video/ogg"];

                if (!videoTypes.includes(file.type)) {
                  snackbar.error(
                    "Please select a valid video file (MP4, WEBM, OGG)."
                  );
                  return;
                }

                setVideoFile(file);
                const previewUrl = URL.createObjectURL(file);
                setVideoPreview(previewUrl);

                // Clear channel URL when video is selected
                setChannelUrl("");
              }}
            />
          </div>
          <div className="d-flex justify-content-end gap-3">
            <button
              className="btn btn-sm border"
              onClick={() => {
                setAddModal(false);
                setDocId("");
                setPreview("");
                setVideoFile(null);
                setVideoPreview("");
                setChannelUrl("");
                setPriority("");
                setTitle("");
                setType("");
                setFile(null);
              }}
            >
              Cancel
            </button>
            <button className="btn btn-sm btn-primary" onClick={addData}>
              Submit
            </button>
          </div>
        </ModalBody>
      </Modal>
      <Modal centered isOpen={deleteModal}>
        <ModalBody>
          <div className="py-4">
            <div className="d-flex justify-content-center">
              <GoInfo className="text-danger" size={40} />
            </div>
            <div className="text-center mt-3">
              Are you sure want to delete this slider image?
            </div>
          </div>
          <div className="d-flex justify-content-end gap-3">
            <button
              className="btn btn-sm border"
              onClick={() => {
                setDeleteModal(false);
                setDeleteId("");
              }}
            >
              Cancel
            </button>
            <button className="btn btn-sm btn-primary" onClick={deleteBanner}>
              Delete
            </button>
          </div>
        </ModalBody>
      </Modal>
      <h2 className="fw-600">TV Sliders</h2>
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-primary btn-radius px-3"
          onClick={() => {
            setType(activeTab); // Set default type to current tab
            setAddModal(true);
          }}
        >
          Add Banner
        </button>
      </div>
      {/* ---------------- Tabs To Switch ---------------- */}
      <div className="d-flex gap-2 m-2">
        <div
          className={`px-4 py-2 rounded cursor-pointer 
      ${
        activeTab === "tv"
          ? "bg-primary text-white shadow-sm"
          : "bg-light border"
      }
    `}
          onClick={() => handleTabClick("tv")}
        >
          TV
        </div>

        <div
          className={`px-4 py-2 rounded cursor-pointer 
      ${
        activeTab === "mobile"
          ? "bg-primary text-white shadow-sm"
          : "bg-light border"
      }
    `}
          onClick={() => handleTabClick("mobile")}
        >
          Mobile
        </div>
      </div>
      <div className="mt-4">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>SNo.</TableCell>
                <TableCell>Content</TableCell>
                {/* <TableCell>Type</TableCell> */}
                <TableCell>Priority</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data?.map((res, index) => {
                return (
                  <TableRow hover key={index}>
                    <TableCell
                      className="pointer text-capitalize"
                      style={{ width: "25%" }}
                    >
                      {res?.sno}
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#666",
                              minWidth: "50px",
                            }}
                          >
                            Banner:
                          </span>
                          <img
                            src={`${baseUrl}/${res?.fileData?.fileUrl}`}
                            width="120px"
                            height="60px"
                            alt="Banner"
                            style={{
                              objectFit: "cover",
                              borderRadius: "4px",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>

                        {res?.additionalData?.type === "url" && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "#666",
                                minWidth: "50px",
                              }}
                            >
                              URL:
                            </span>
                            <a
                              href={res?.additionalData?.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                fontSize: "12px",
                                textDecoration: "none",
                                color: "#007bff",
                              }}
                            >
                              {res?.additionalData?.name || "Channel Link"}
                            </a>
                          </div>
                        )}

                        {res?.additionalData?.type === "video" && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "#666",
                                minWidth: "50px",
                              }}
                            >
                              Video:
                            </span>
                            <video
                              src={res?.additionalData?.url}
                              width="120px"
                              height="60px"
                              controls
                              style={{
                                objectFit: "cover",
                                borderRadius: "4px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </TableCell>
                    <TableCell>{res?.priority}</TableCell>
                    <TableCell>
                      <FaRegEdit
                        size={20}
                        className="text-primary pointer"
                        onClick={() => {
                          setDocId(res?._id);
                          // Prefill form fields with existing data
                          setPriority(res?.priority || "");
                          setTitle(res?.title || "");
                          setType(res?.type || "");

                          // Handle existing video or channelUrl data properly
                          if (res?.additionalData?.type === "video") {
                            // It's a video - set video preview and clear channelUrl
                            setVideoPreview(res?.additionalData?.url || "");
                            setChannelUrl("");
                          } else if (res?.additionalData?.type === "url") {
                            // It's a channel URL - set channelUrl and clear video
                            setChannelUrl(res?.additionalData?.url || "");
                            setVideoPreview("");
                            setVideoFile(null);
                          } else {
                            // No additional data - clear both
                            setChannelUrl("");
                            setVideoPreview("");
                            setVideoFile(null);
                          }

                          // Set banner preview
                          if (res?.fileData?.fileUrl) {
                            setPreview(res?.fileData?.fileUrl);
                          }

                          setAddModal(true);
                        }}
                      />
                      <AiTwotoneDelete
                        size={20}
                        className="text-primary pointer"
                        onClick={() => {
                          setDeleteModal(true);
                          setDeleteId(res?._id);
                          setDeleteImg(res?.fileData?.fileName);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>

          {/* <TablePagination
                        component="div"
                        count={totalData}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
        </TableContainer>
      </div>
    </>
  );
}
